import * as v from 'valibot';

import { newSchema } from '../../../../../utils/valibot/schema';

export const RetailCrmSyncToGcdmResponseSchema = newSchema(
  'RetailCrmSyncToGcdmResponseSchema',
  v.object({
    success: v.boolean(),
    id: v.optional(v.string()),
  }),
);

export type RetailCrmSyncToGcdmResponse = v.InferOutput<typeof RetailCrmSyncToGcdmResponseSchema>;
